import { render, staticRenderFns } from "./IntervenerCard.vue?vue&type=template&id=6b11c3f6"
import script from "./IntervenerCard.vue?vue&type=script&lang=js"
export * from "./IntervenerCard.vue?vue&type=script&lang=js"
import style0 from "./IntervenerCard.vue?vue&type=style&index=0&id=6b11c3f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports